class SwiperSlider extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }
  }

    connectedCallback() {
        this.slider = this.querySelector(this.selectors.swiper);
        this.buttonPrev = this.querySelector(this.selectors.prevEl);
        this.buttonNext = this.querySelector(this.selectors.nextEl);
        this.options = this.slider.getAttribute('data-options');

        if(!this.slider) {
                return null;
            }
        this.initSlider();
        this.addListeners();
    }

  initSlider() {

    let inlineOptions = this.slider.dataset.options;

    if(inlineOptions){
        inlineOptions = JSON.parse(inlineOptions);
    }

    console.log(inlineOptions)
    this.swiperParams = {
      slidesPerView: 2.331,
      spaceBetween: 12,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      watchSlidesProgress: true,
      breakpoints: {
        480: {
          slidesPerView: "auto",
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      on: {
        init() {
        }
      },
      ...inlineOptions
    };

    Object.assign(this.slider, this.swiperParams);

    this.slider.initialize();
  }

    addListeners() {
        document.addEventListener('shopify:section:reorder', () => this.initSlider());
        document.addEventListener('shopify:section:load',() => this.initSlider());
        document.addEventListener('shopify:section:select', () => this.initSlider());
        document.addEventListener('shopify:section:deselect', () => this.initSlider());
    }
}

customElements.define('component-swiper-slider', SwiperSlider);
